<script setup lang="ts">
import { defineQuery } from "groq";
import { NuggetCard } from "#components";

const NUGGETS_QUERY = defineQuery(`*[_type == "nugget"]{
    _id,
    displayedId,
    type,
    text,
    slug,
    author->{name, slug},
    book->{title, slug},
    music->{title, slug},
  } | order(displayedId desc)`);
const { data: nuggets, status } = useSanityQuery(NUGGETS_QUERY);
</script>

<template>
  <UContainer>
    <div class="flex flex-wrap gap-x-24 gap-y-16 mt-24 place-content-center">
      <div
        v-for="(nugget, index) in nuggets"
        :key="nugget._id"
        class="flex items-center justify-center"
      >
        <NuggetCard
          :nugget="nugget"
          :status="status"
          :class="{
            '-rotate-1': index % 2 === 0,
            'rotate-2': index % 2 !== 0,
          }"
        />
      </div>
    </div>
  </UContainer>
</template>
